//import { fromJS } from 'immutable';
import {
  RoleUserAdmin,
  RoleCustomerService,
  RoleUploaderStaff,
  RoleUploaderSPV,
  RoleCSAgent,
  RoleCSSPV
} from '../../../store/constants';

export const Menus = [
  {
    "Id": 0,
    "label": "Home",
    "route": "/Home",
    "icon": "home",
    "parent":"/Home",
    "Roles": [
      RoleUserAdmin, RoleCustomerService, RoleUploaderSPV, RoleUploaderStaff, RoleCSAgent, RoleCSSPV
    ]
  },
  {
    "Id": 0,
    "label": "Dashboard",
    "route": "#",
    "icon": "dashboard",
    "Roles": [
      RoleUserAdmin, RoleCustomerService, RoleUploaderSPV, RoleUploaderStaff, RoleCSAgent, RoleCSSPV
    ],
    "Items": [
      {
        "Id": 45,
        "label": "Push Dashboard",
        "route": "/DashboardPushSummary",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },   
      {
        "Id": 44,
        "label": "Interactive Dashboard ",
        "route": "/PushInteractive",
        "Roles": [
          RoleUserAdmin,RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 54,
        "label": "Smart Marketing Dashboard ",
        "route": "/DashboardSmartMarketing",
        "Roles": [
          RoleUserAdmin,RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      }
    ]
  },
  {
    "Id": 0,
    "label": "PushNotification",
    "route": "#",
    "icon": "notifications",
    "parent":"/PushNotification",
    "Roles": [
      RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
    ],
    "Items": [
      {
        "Id": 1,
        "label": "List Upload",
        "route": "/ListUpload",
        // "icon": 'list',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 43,
        "label": "Check Contact",
        "route": "/CheckContact",
        // "icon": 'attachment',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 50,
        "label": "Upload Media Id",
        "route": "/UploadMediaId",
        // "icon": 'attachment',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 2,
        "label": "Single Text",
        "route": "/UploadSingle",
        "parent":"/PushNotification",
        // "icon": 'cloud_upload',
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 3,
        "label": "Single Media",
        "route": "/SingleUpload",
        "parent":"/PushNotification",
        // "icon": 'attachment',
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 4,
        "label": "Personal Text",
        "route": "/PersonalUpload",
        // "icon": 'cloud_upload',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 5,
        "label": "Personal Media",
        "route": "/PersonalUploadMedia",
        // "icon": 'attachment',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 6,
        "label": "Personal Scheduler Text",
        "route": "/scheduled",
        // "icon": 'cloud_upload',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 7,
        "label": "Personal Scheduler Media",
        "route": "/PersonalScheduleUpload",
        // "icon": 'attachment',
        "parent":"/PushNotification",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      }
    ]
  },
  {
    "Id": 0,
    "label": "Helpdesk",
    "route": "#",
    "icon":"person",
    "Roles": [
      RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
    ],
    "Items": [
      {
        "Id": 10,
        "label": "Inbox",
        "route": "/inbox",
        // "icon":"message",
        "Roles": [
          RoleUserAdmin,RoleCSAgent, RoleCSSPV
        ]
      },
      {
        "Id": 8,
        "label": "Supervisor",
        "route": "/Spv",
        // "icon":"person",
        "Roles": [
          RoleUserAdmin
        ]
      },
      
      {
        "Id": 9,
        "label": "Customer Service",
        "route": "/Cs",
        // "icon":"person",
        "Roles": [
          RoleUserAdmin
        ]
      },
      
      {
        "Id": 11,
        "label": "History",
        "route": "/TicketHistory",
        // "icon":"history",
        "Roles": [
          RoleCSAgent, RoleCSSPV,RoleUserAdmin
        ]
      },
      
    ]
  },
  {
    "Id": 0,
    "label": "Settings",
    "route": "#",
    "icon": "settings",
    "Roles": [
      RoleUserAdmin
    ],
    "Items": [
      {
        "Id": 48,
        "label": "Division",
        "route": "/division",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 47,
        "label": "Sender",
        "route": "/sender",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 14,
        "label": "Settings Category",
        "route": "/category",
        // "icon":"list",
        "Roles": [
          RoleUserAdmin
        ]
      },
      ,
      {
        "Id": 15,
        "label": "Priority",
        "route": "/priority",
        // "icon":"low_priority",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 16,
        "label": "Business Hour",
        "route": "/businesshour",
        // "icon":"access_time",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 17,
        "label": "Predefined Template",
        "route": "/Template",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 18,
        "label": "Change WA Profile",
        "route": "/waprofilesetting",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id": 53,
        "label": "Check Template Id",
        "route": "/TemplateChecker",
        // "icon": 'attachment',
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 19,
        "label": "List Template",
        "route": "/HsmTemplate",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 36,
        "label": "Register Template",
        "route": "/RegisterTemplate",
        // "icon":"group_work",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 37,
        "label": "Flow Template",
        "route": "/FlowTemplate",
        // "icon":"group_work",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 41,
        "label": "Mapping Template Sender",
        "route": "/templateSender",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id":42,
        "label": "Settings Transmitter",
        "route": "/transmittersetting",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      },
      {
        "Id":42,
        "label": "Backlog Client Management",
        "route": "/backlogclient",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin
        ]
      },
    ]
  },
  {
    "Id": 0,
    "label": "Integration View",
    "route": "#",
    "icon": "book",
    "Roles": [
      RoleUserAdmin
    ],
    "Items": [
      {
        "Id":52,
        "label": "Quality Rating",
        "route": "/QualityRating",
        // "icon":"subject",
        "Roles": [
          RoleUserAdmin,RoleUploaderStaff, RoleUploaderSPV
        ]
      }
    ]
  },
  {
    "Id": 0,
    "label": "User Management",
    "route": "#",
    "icon": "people",
    "Roles": [
      RoleUserAdmin
    ],
    "Items": [

      {
        "Id": 23,
        "label": "Privilege",
        "route": "/Privilage",
        // "icon": "stars",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 24,
        "label": "Access Module",
        "route": "/accessmodules",
        // "icon": "verified_user",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 25,
        "label": "User",
        "route": "/User",
        // "icon": "person",
        "Roles": [
          RoleUserAdmin
        ]
      },
    ]
  },
  {
    "Id": 0,
    "label": "Chatbot",
    "route": "#",
    "icon": "chat",
    "Roles": [
      RoleUserAdmin
    ],
    "Items":[
      {
        "Id": 26,
        "label": "Key Group",
        "route": "/keygroup",
        // "icon":"group_work",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 27,
        "label": "Reply",
        "route": "/Reply",
        // "icon":"reply",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 28,
        "label": "Invalid Reply",
        "route": "/invalidReply",
        // "icon":"error",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 35,
        "label": "Replies Close Ticket",
        "route": "/RepliesCloseTicket",
        // "icon":"group_work",
        "Roles": [
          RoleUserAdmin
        ]
      }

    ]
  },
  {
    "Id": 0,
    "label": "Report",
    "route": "#",
    "icon":"bar_chart",
    "Roles": [
      RoleUserAdmin
    ],
    "Items": [
      
      {
        "Id": 29,
        "label": "Report Broadcast",
        "route": "/ReportBroadcast",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 30,
        "label": "Report Chatbot ",
        "route": "/ReportInteractive",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 31,
        "label": "Report Helpdesk",
        "route": "/ReportHelpdesk",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id":49,
        "label": "Report Button",
        "route": "/ReportButton",
        "Roles": [
          RoleUserAdmin
        ]
      },
      {
        "Id": 51,
        "label": "Report Pricing",
        "route": "/ReportSession",
        "Roles": [
          RoleUserAdmin
        ]
      }
    ]
  }
];
